import ActivityLogCollection from 'collections/activity_log';
import datenav from 'core/controllers/date_navigation';


export default ActivityLogCollection.extend({
  initialize: function () {
    _.bindAll(this, 'add', 'last_n', '_add', '_is_dupe');
  },

  add: function (options) {
    if (_.isArray(options)) {
      _.each(options, this._add);
    } else {
      this._add(options);
    }
  },

  last_n: function (n) {
    return new ActivityLogCollection(this.slice(0 - n));
  },

  _add: function (activity_log) {
    // No dupes allowed in recent activities, keep only the latest
    // logging of each activity
    if (this._is_dupe(activity_log)) {
      return false;
    }
    Backbone.Collection.prototype.add.call(this, activity_log);
  },

  _is_dupe: function (activity_log) {
    // Return if this activity_log is a dupe
    // If it is a dupe, but has a later date than an existing record,
    // replace the existing record with this new record.
    var self = this;
    return this.some(function (_activity_log) {
      if (_activity_log && _activity_log.get('activity') === activity_log.get('activity')) {
        var d1 = datenav.parse_date(activity_log.get('date'));
        var d2 = datenav.parse_date(_activity_log.get('date'));
        if (d1 > d2) {
          self.remove(_activity_log);
          return false;
        }
        return true;
      }
      return false;
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/recent_activity_log.js